//#region src/tools/support/snapshots/formatting.ts
function getSnapshotImageDisplayName(img) {
	return img.display_name || img.image_file_name || "unknown";
}
function formatSnapshotDiffPercent(diff) {
	return `${Math.round(diff * 1e4) / 100}%`;
}
function renderSnapshotImageTreeSection(title, items) {
	if (items.length === 0) return [];
	const root = createBranch("");
	for (const item of items) addItemToBranch(root, item);
	const lines = [`**${title}:**`];
	const entries = collectChildEntries(root);
	for (const [index, entry] of entries.entries()) lines.push(renderEntry(entry, "", index === entries.length - 1));
	return lines;
}
function renderSnapshotImageContext(context) {
	return isPlainObject(context) ? renderContextObject(context, 0) : [];
}
function createBranch(label) {
	return {
		kind: "branch",
		label,
		children: /* @__PURE__ */ new Map(),
		leaves: []
	};
}
function addItemToBranch(root, item) {
	const identifier = getSnapshotImageIdentifier(item.image);
	const segments = identifier.split("/").filter(Boolean);
	const pathSegments = segments.length > 0 ? segments : [identifier];
	const leafName = pathSegments[pathSegments.length - 1] ?? identifier;
	let node = root;
	for (const segment of pathSegments.slice(0, -1)) {
		let child = node.children.get(segment);
		if (!child) {
			child = createBranch(`${segment}/`);
			node.children.set(segment, child);
		}
		node = child;
	}
	node.leaves.push({
		kind: "leaf",
		label: formatLeafLabel(leafName, item.image, item.details ?? [])
	});
}
function getSnapshotImageIdentifier(img) {
	return img.image_file_name || getSnapshotImageDisplayName(img);
}
function formatLeafLabel(leafName, img, details) {
	const displayName = getSnapshotImageDisplayName(img);
	const suffixes = [...details];
	if (displayName !== leafName && displayName !== img.image_file_name) suffixes.push(displayName);
	if (img.group && String(img.group) !== displayName) suffixes.push(String(img.group));
	return suffixes.length > 0 ? `${leafName} — ${suffixes.join(" — ")}` : leafName;
}
function collectChildEntries(branch) {
	return [...branch.children.values(), ...branch.leaves];
}
function renderEntry(entry, prefix, isLast) {
	const connector = isLast ? "└── " : "├── ";
	if (entry.kind === "leaf") return `${prefix}${connector}${entry.label}`;
	const childPrefix = `${prefix}${isLast ? "    " : "│   "}`;
	const children = collectChildEntries(entry);
	const lines = [`${prefix}${connector}${entry.label}`];
	for (const [index, child] of children.entries()) lines.push(renderEntry(child, childPrefix, index === children.length - 1));
	return lines.join("\n");
}
function renderContextObject(context, depth) {
	const prefix = "  ".repeat(depth);
	return Object.entries(context).flatMap(([key, value]) => {
		const formatted = formatSupportedContextValue(value);
		if (formatted !== null) return [`${prefix}- **${key}**: ${formatted}`];
		if (!isPlainObject(value)) return [];
		const children = renderContextObject(value, depth + 1);
		return children.length > 0 ? [`${prefix}- **${key}**:`, ...children] : [];
	});
}
function formatSupportedContextValue(value) {
	if (typeof value === "string") {
		const normalized = value.trim().replace(/\s+/g, " ");
		return normalized.length > 0 ? normalized : null;
	}
	if (typeof value === "number") return Number.isFinite(value) ? String(value) : null;
	if (typeof value === "boolean") return String(value);
	return null;
}
function isPlainObject(value) {
	if (value === null || typeof value !== "object") return false;
	const prototype = Object.getPrototypeOf(value);
	return prototype === Object.prototype || prototype === null;
}

//#endregion
export { formatSnapshotDiffPercent, getSnapshotImageDisplayName, renderSnapshotImageContext, renderSnapshotImageTreeSection };
//# sourceMappingURL=formatting-C_fxwUSt.js.map